import { createTheme } from '@mui/material/styles';
import imageBackground from 'asset/login-background.svg';

export const PRIMARY_DARK = '#002D74';

export const PRIMARY = '#1976D2';

export const PRIMARY_ALLIANT = '#1FBDC9';

export const PRIMARY_DARK_ALLIANT = '#002E42';

export const PRIMARY_ALLIANT_LIGHT = '#85D2DD';

export const PRIMARY_WARNING = '#ff1744';

export const PRIMARY_35 = '#AECFEF';

export const PRIMARY_DEEP_DARK = '#002D74';

export const CHECK_GREEN = '#00BE5F';

export const RUNNING_ORANGE = '#FCBA03';

export const DISABLE_GRAY = '#A2A2A3';

export const WHITE = '#FFFFFF';

export const BLACK = '#000000';

export const CENSUS_MALE = '#0088FE';

export const CENSUS_FEMALE = '#00C49F';

export const CENSUS_OTHER = '#808080';

export const SPOUSE_RELATIONSHIP = '#8d9690';

export const BENCHMARK_MALE = '#8ECEFD';

export const BENCHMARK_FEMALE = '#F88B9D';

export const BENCHMARK_OTHER = '#404040';

export const CENSUS_OTHER_ALLIANT = '#656D70';

export const BENCHMARK_MALE_ALLIANT = '#6DA5AF';

export const BENCHMARK_FEMALE_ALLIANT = '#c1d7db';

export const DEFAULT_BACKGROUND = '#F0F2F5';

export const ALLIANT_BACKGROUND = '#f1f6f7';

export const DEFAULT_SPINNER = '#1a90ff';

export const DEFAULT_MASKBOX = '#c2d3fc';

export const ERROR_LOGIN = '#88041e';
export const blueTheme = createTheme({
  palette: {
    primary: {
      main: PRIMARY_35,
      dark: PRIMARY_35,
    },
  },
});

export const loginTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        backgroundImage: `url(${imageBackground})`,
      },
    },
  },
});

export const steps = () => [
  {
    label: 'Scenario Information',
    code: 'SCENARIO_INFORMATION',
  },
  {
    label: 'Demographics',
    code: 'DEMOGRAPHICS',
  },
  {
    label: 'Policies',
    code: 'POLICIES',
  },
  {
    label: 'Coverage',
    sublabel: ['Hospital Indemnity', 'Critical Illness', 'Accident'],
    code: 'COVERAGE',
  },
  {
    label: 'Compare Plans',
    code: 'COMPARE_PLANS',
  },
  {
    label: 'Output',
    code: 'OUTPUT',
  },
];

export const publicSteps = new Set(['SCENARIO_INFORMATION', 'DEMOGRAPHICS', 'POLICIES', 'COVERAGE', 'OUTPUT']);

export const genderBenchmark = [
  {
    bmkPercentage: 52.5,
    bmkGender: 'male',
  },
  {
    bmkPercentage: 46.5,
    bmkGender: 'female',
  },
  {
    bmkPercentage: 1,
    bmkGender: 'others',
  },
];

export const relationshipBenchmark = [
  {
    bmkPercentage: 24.8,
    bmkRelationship: 'children',
  },
  {
    bmkPercentage: 61.6,
    bmkRelationship: 'employee',
  },
  {
    bmkPercentage: 13.6,
    bmkRelationship: 'spouse',
  },
];

export const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export const doubleCurrencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

export const intFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export const doubleFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export const percFormatterNoDecimal = new Intl.NumberFormat('en-US', { style: 'percent' });

export const precFormatter = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 2, minimumFractionDigits: 2 });

export const percFormatterMinZero = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 2, minimumFractionDigits: 0 });

export const calculateMaximumDay = (day, type, maxDays) => {
  if (parseInt(day, 10) < 0 || !Number.isInteger(parseInt(day, 10))) { return 0; }
  if (type in maxDays) {
    const n = maxDays[type].length;
    return maxDays[type][Math.min(parseInt(day, 10), n - 1)];
  }
  return 0;
};

export const pageSizeOptionList = [10, 25, 50, 100];
export const defaultPageSize = pageSizeOptionList[0];
export const defaultOrder = 'DESC';

export const CARRIER_TOKEN = '{CARRIER}';
export const PDF_MESSAGE = `** THIS IS FOR ${CARRIER_TOKEN} INTERNAL USE ONLY!`;

export const POLICY_MODULE_TYPE = { PERIOD: 'PERIOD', ORIGINAL: 'ORIGINAL', FRACT: 'FRACT' };
export const POLICY_ITEM_TYPE = {
  PERIOD: 'PERIOD', ORIGINAL: 'ORIGINAL', FRACT: 'FRACT', PERCENTAGE: 'PERCENTAGE',
};
export const POLICY_CODE = { HI: 'HI', CI: 'CI', AC: 'AC' };

export const AFLAC = {
  CODE: 'AFLAC',
  PATHNAME: '/aflac',
};
export const BST = {
  CODE: 'BST',
  PATHNAME: '/login',
  PATHNAME_DEFAULT: '/',
};

export const WELLNESS_BENEFIT_MONEY_SPENT = 'Wellness benefit money spent';
export const MONEY_SPENT_DEFAULT = 'Projected Claims';
export const TOOLTIP_CONTENT = 'The projected claims in the modules below are determined by the values included in the General Policy Provisions.';

export const STATUS_CODE = {
  PYTHON_INVALID: 'PYTHON_INVALID',
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
};

export const DEPENDENCY_OBJ_LIST = [
  {
    code: 'TOTAL',
    claimCode: 'totalCount',
    CICode: '',
  },
  {
    code: 'EMPLOYEE',
    claimCode: 'employeeCount',
    CICode: 'faceValue',
  },
  {
    code: 'SPOUSE',
    claimCode: 'spouseCount',
    CICode: 'adultDp',
  },
  {
    code: 'CHILDREN',
    claimCode: 'childrenCount',
    CICode: 'minorDp',
  },
];

export const getBestBenefitPrice = (price) => Math.round(
  Math.ceil((price * 1.25) / 25) * 25,
);

export const DOMAIN_PREFIX_REGEX = /^https?:\/\/[^/]+/;

export const specificBenefitChecked = {
  BST: {
    HI: 'wellnessVisitChecked',
    CI: 'wellnessChecked',
    AC: 'wellnessChecked',
  },
  AFLAC: {
    HI: 'healthScreeningChecked',
    CI: 'healthScreenChecked',
    AC: 'healthScreeningChecked',
  },
  ALLSTATE: {
    HI: 'wellnessVisitChecked',
    CI: 'healthScreenChecked',
    AC: 'healthScreeningChecked',
  },
};

export const policyDisplayNames = {
  HI: 'Hospital Indemnity',
  CI: 'Critical Illness',
  AC: 'Accident',
};

export const fixedProductPriority = {
  AC: 1,
  HI: 2,
  CI: 3,
};

export const avgHospitalBenefits = {
  BST: {
    benefit1: 'nonIcuAdmission',
    benefit1Checked: 'nonIcuAdmissionChecked',
    benefit2: 'nonIcuPerDiem',
    benefit2Checked: 'nonIcuPerDiemChecked',
  },
  AFLAC: {
    benefit1: 'admission',
    benefit1Checked: 'admissionChecked',
    benefit2: 'confinement',
    benefit2Checked: 'confinementChecked',
  },
  ALLSTATE: {
    benefit1: 'firstDayHospitalConfinement',
    benefit1Checked: 'firstDayHospitalConfinementChecked',
    benefit2: 'dailyHospitalConfinement',
    benefit2Checked: 'dailyHospitalConfinementChecked',
  },
};

export const NUMBERS_ROUNDED_TEXT = 'Numbers are rounded to the nearest whole number according to the standard rounding rules. Ex. 6.4 rounded to 6 and 6.6 rounded to 7';

export const COMPARISON_CLAIMS_TEXT = 'Claim number is based on the participation rate';

export const premiumTypes = [
  { type: 'Employee Only', name: 'EE' },
  { type: 'Employee + Spouse', name: 'ES' },
  { type: 'Employee + Child(ren)', name: 'EC' },
  { type: 'Employee + Family', name: 'EF' },
];

export const frequencyOptions = [
  {
    code: 'SELECT',
    text: 'Select',
  },
  {
    code: 'MONTHLY',
    text: 'Monthly',
  },
  {
    code: 'ANNUAL',
    text: 'Annually',
  },
  {
    code: 'WEEKLY',
    text: 'Weekly',
  },
  {
    code: 'BIWEEKLY',
    text: 'Biweekly',
  },
];

export const smokerOptions = [
  {
    code: 'SELECT',
    text: 'Select',
  },
  {
    code: 'UNISMOKER',
    text: 'Unismoker',
  },
  {
    code: 'SMOKER',
    text: 'Nonsmoker/Smoker',
  },
];

export const premiumAges = ['25', '35', '45', '55', '65'];

export const regionOptions = ['All', 'South', 'Midwest', 'Northeast', 'West', 'N/A'];

export const comparisonOperators = ['=', '>=', '<='];

export const defaultFilters = {
  name: '',
  employerName: '',
  region: ['All'],
  numOfMembers: { value: '', operator: '=' },
  userName: '',
  createdAt: { value: '', operator: '=' },
};

export const getComparePlanObjectHighLow = (pPercent) => [
  {
    code: POLICY_CODE.HI,
    displayName: 'Hospital Indemnity - Benefit 1',
    highLowCode: 'HI',
    isHidden: pPercent.HI.participationPerc1 === 0,
  },
  {
    code: POLICY_CODE.HI,
    displayName: 'Hospital Indemnity - Benefit 2',
    highLowCode: 'HI2',
    isHidden: pPercent.HI.participationPerc2 === 0,
  },
  {
    code: POLICY_CODE.CI,
    displayName: 'Critical Illness',
    highLowCode: 'CI',
  },
  {
    code: POLICY_CODE.AC,
    displayName: 'Accident - Benefit 1',
    highLowCode: 'AC',
    isHidden: pPercent.AC.participationPerc1 === 0,
  },
  {
    code: POLICY_CODE.AC,
    displayName: 'Accident - Benefit 2',
    highLowCode: 'AC2',
    isHidden: pPercent.AC.participationPerc2 === 0,
  },
];

export const premiumTypeMapper = {
  EE: 'Employee Only',
  ES: 'Employee + Spouse',
  EC: 'Employee + Child(ren)',
  EF: 'Employee + Family',
};

export const getPlanComparisonSections = ({
  pPercent,
  HIPremiumsInfo,
  CIPremiumsInfo,
  ACPremiumsInfo,
}) => [
  {
    code: POLICY_CODE.HI,
    displayName: 'Hospital Indemnity - Benefit 1',
    highLowCode: 'HI',
    isHidden: pPercent.HI.participationPerc1 === 0,
  },
  {
    code: POLICY_CODE.HI,
    displayName: 'Hospital Indemnity - Benefit 2',
    highLowCode: 'HI2',
    isHidden: pPercent.HI.participationPerc2 === 0,
  },
  {
    code: POLICY_CODE.HI,
    displayName: 'Hospital Indemnity - Premiums',
    highLowCode: 'HIPremiums',
    isHidden: !HIPremiumsInfo.includePremiumHI
                      || HIPremiumsInfo.premiums?.every((el) => el.premium === 0),
    isPremiums: true,
  },
  {
    code: POLICY_CODE.CI,
    displayName: 'Critical Illness',
    highLowCode: 'CI',
  },
  {
    code: POLICY_CODE.CI,
    displayName: 'Critical Illness - Premiums',
    highLowCode: 'CIPremiums',
    isHidden: !CIPremiumsInfo.includePremiumCI
                      || CIPremiumsInfo.premiums?.every((el) => el.premium === 0),
    isPremiums: true,
    isSmoker: CIPremiumsInfo.premiumTypeCI === 'SMOKER',
  },
  {
    code: POLICY_CODE.AC,
    displayName: 'Accident - Benefit 1',
    highLowCode: 'AC',
    isHidden: pPercent.AC.participationPerc1 === 0,
  },
  {
    code: POLICY_CODE.AC,
    displayName: 'Accident - Benefit 2',
    highLowCode: 'AC2',
    isHidden: pPercent.AC.participationPerc2 === 0,
  },
  {
    code: POLICY_CODE.AC,
    displayName: 'Accident - Premiums',
    highLowCode: 'ACPremiums',
    isHidden: !ACPremiumsInfo.includePremiumAC
                      || ACPremiumsInfo.premiums?.every((el) => el.premium === 0),
    isPremiums: true,
  },
];
